import React, { createContext, useContext, useState } from "react";
import { PinnedMessage } from "./RoomChatTypes";

export type ChatContextType = {
    isChatOpen: boolean;
    setIsChatOpen: (open: boolean) => void;
    pinnedMessage: PinnedMessage | undefined;
    setPinnedMessage: (message: PinnedMessage) => void;
};

export const ChatContext: React.Context<ChatContextType | undefined> = createContext<ChatContextType | undefined>(
    undefined,
);

interface ChatContextProviderProps {
    children?: React.ReactNode;
}

export const ChatContextProvider = ({ children }: ChatContextProviderProps) => {
    const [isChatOpen, setIsChatOpen] = useState<boolean>(false);
    const [pinnedMessage, setPinnedMessage] = useState<PinnedMessage>();

    return (
        <ChatContext.Provider
            value={{
                isChatOpen,
                setIsChatOpen,
                pinnedMessage: pinnedMessage,
                setPinnedMessage: setPinnedMessage,
            }}
        >
            {children}
        </ChatContext.Provider>
    );
};

export const useChatContext = () => {
    const context = useContext(ChatContext);
    if (context == null) {
        throw new Error("Missing ChatContext");
    }
    return context;
};
